export default {
  name: 'DatePickerCalendarMonthLayout',
  props: {
    monthList: {
      type: Array,
      default: () => []
    }
  }
};